import React from 'react';
import { connect } from 'react-redux';

import ufcLogo from '../../assets/images/ufc-logo.png';
import classes from './Logo.css';
import packageJson from '../../package.alias.json'

const logo = (props) => {
  // Split version: "v0.7.0-c2cf7b6-dev" -> semantic: "v0.7.0", build: "c2cf7b6-dev"
  const fullVersion = packageJson.version;
  const versionParts = fullVersion.split('-');
  const semanticVersion = versionParts[0]; // "v0.7.0"
  const buildInfo = versionParts.slice(1).join('-'); // "c2cf7b6-dev" or "c2cf7b6"

  return (
    <a href="/" className={classes.Logo} style={{ height: props.height }}>
      <img src={ufcLogo} alt="UFC" style={{ verticalAlign: "middle" }} />
      <h3 className={classes.Kanban}>
        Kanban {semanticVersion}
        {buildInfo && (
          <React.Fragment>
            <br />
            <span style={{ fontSize: '0.7em', fontWeight: 'normal' }}>{buildInfo}</span>
          </React.Fragment>
        )}
      </h3>
    </a>
  );
};

const mapStateToProps = state => {
  return {
    name: state.name
  };
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(logo);



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js